import { ADJUSTER_REPORT_BASE_PATH } from '@/config/baseModulesLink';
import { ADJUSTER_REPORT_CULPRIT_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';

export const SHOW_POLICE_REPORT_BASE_PATH = 'show-police-report';
export const SHOW_ADJUSTER_OPINION_BASE_PATH = 'show-adjuster-opinion';
export const POLICE_REPORT_BASE_PATH = 'police-report';
export const ADJUSTER_OPINION_BASE_PATH = 'adjuster-opinion';

export const ADJUSTER_REPORT_LINKS = {
  CULPRIT_INFORMATION_PAGE: ({ id }: { id: number; culpritId: number }) =>
    ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_INFORMATION({
      id,
    }).culpritInformationTabsPage,

  adjusterReport: (id: string) => `/${ADJUSTER_REPORT_BASE_PATH}/${id}`,
  policeReport: {
    edit: (id: string) =>
      `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${POLICE_REPORT_BASE_PATH}`,
    show: (id: string) =>
      `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${SHOW_POLICE_REPORT_BASE_PATH}`,
  },
  adjusterOpinion: {
    edit: (id: string) =>
      `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${ADJUSTER_OPINION_BASE_PATH}`,
    show: (id: string) =>
      `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${SHOW_ADJUSTER_OPINION_BASE_PATH}`,
  },
};
